goog.provide("el8.marketing.providerPassportLeadGen");

goog.require("el8.template.marketing.providerPassportLeadGen");

var el8 = el8 || {};
if (!el8.marketing) {
    el8.marketing = {};
}

el8.marketing.providerPassportLeadGen = (function () {
    var that = {};

    function start() {
        $.el8_ajax({
            type: "GET",
            url: "/access/provider-passport-lead-gen/",
            async: true,
            success: function (data) {
                if (!data.error) {
                    if (data.enabled) {
                        setTimeout(function () {
                            show(data);
                        }, 2000);
                    }
                }
            },
        });
    }

    function handleLeadGenResponse(responseType, closeFloater) {
        if (closeFloater) {
            hide();
        }

        $.el8_ajax({
            type: "POST",
            url: "/access/provider-passport-lead-gen/",
            data: JSON.stringify({ response_type: responseType }),
            async: true,
            success: function (data) {
                if (!data.error) {
                    that.leadGenResponseId = data.response_id;
                }
            },
            error: function (data) {},
        });
    }

    function submitNoDemoReason() {
        var reason = $("#no-demo-reason-input").val();
        $.el8_ajax({
            type: "POST",
            url: "/access/provider-passport-lead-gen/",
            data: JSON.stringify({
                lead_gen_response_id: that.leadGenResponseId,
                reason: reason,
            }),
            async: true,
            success: function (data) {},
            error: function (data) {},
        });
    }

    function hide() {
        $("#tourguide-splash").addClass("hidden");
    }

    function show(leadGenData) {
        $("body").append(
            el8.template.marketing.providerPassportLeadGen.content()
        );

        var container = $(".tourGuideDialogContainer");
        container.html(
            el8.template.marketing.providerPassportLeadGen.leadGenFloater({
                role: leadGenData["role"],
            })
        );

        var content = container;
        content.on("click", "#demo-button", function (event) {
            handleLeadGenResponse("demo", false);

            container.html(
                el8.template.marketing.providerPassportLeadGen.leadGenDemoConfirmFloater(
                    {}
                )
            );
            $(".tourGuideSplashDialog").css({ "min-height": 100 });

            setTimeout(function () {
                hide();
            }, 3000);
        });
        content.on("click", "#no-demo-button", function (event) {
            handleLeadGenResponse("nodemo", false);
            container.html(
                el8.template.marketing.providerPassportLeadGen.leadGenNoDemoReason(
                    {}
                )
            );
            $(".tourGuideSplashDialog").css({ "min-height": 100 });

            $("#no-demo-reason-input").focus();
        });
        content.on("click", "#later-button", function (event) {
            handleLeadGenResponse("later", true);
        });
        content.on("click", "#no-demo-reason-submit", function (event) {
            submitNoDemoReason();
            hide();
        });

        $("#tourguide-splash-overlay").css({ height: "100%", width: "100%" });
        var s = $("#tourguide-splash-info");
        if (s.length > 0) {
            s.css({
                "z-index": 30001,
                top: ($(window).height() - s.outerHeight(true)) / 2,
                left: ($(window).width() - s.outerWidth(true)) / 2,
            });
        }
    }

    that.init = function (spec) {
        if (el8Globals.PASSPORT_EMR) {
            start();
        }
    };

    return that;
})();
